import { render } from "./Direct.vue?vue&type=template&id=8a964da4"
import script from "./Direct.vue?vue&type=script&lang=js"
export * from "./Direct.vue?vue&type=script&lang=js"

import "./Direct.vue?vue&type=style&index=0&id=8a964da4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__